import { render, staticRenderFns } from "./SeriesAudiovisualEfileList.vue?vue&type=template&id=1b6ca11d&"
import script from "./SeriesAudiovisualEfileList.vue?vue&type=script&lang=js&"
export * from "./SeriesAudiovisualEfileList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports